/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
// import { Fade } from 'react-reveal';
import { GlobalState } from '../../globalState';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { Link } from 'react-router-dom';
// import i18n from '../../i18n';
// import { useTranslation } from 'react-i18next'
import './projects.css'
import { appAddress } from '../../App';
import { useTranslation } from "react-i18next";

export default function HomeProjects() {
  const state = useContext(GlobalState);
  const [getProjects, setGetProjects] = useState([]);
  const [getProjectsPersian, setGetProjectsPersian] = useState([]);
  const [getProjectsArabic, setGetProjectsArabic] = useState([]);
  const [token] = useSelector((state) => state.token);
  const [callback, setCallback] = state.projectsAPI.callback;
  const { i18n } = useTranslation();

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    i18n.changeLanguage(savedLanguage);

    const rootElement = document.getElementById('root');
    if (savedLanguage === 'fa' || savedLanguage === 'ar') {
      rootElement.classList.remove('ltr', 'text-left');
      rootElement.classList.add('rtl', 'text-right');
    } else {
      rootElement.classList.remove('rtl', 'text-right');
      rootElement.classList.add('ltr', 'text-left');
    }
  }, []);

  const fetchProjects = async () => {
    try {
      // const res = await axios.get('/api/projects', {
        const res = await axios.get(`${appAddress}/api/projects`, {
            headers: { Authorization: token }
        });

        setGetProjects(res.data); 
        setGetProjectsPersian(res.data); 
        setGetProjectsArabic(res.data); 
        setCallback(!callback);
    } catch (err) {
        console.error('Fetch Error:', err);
    }
};

useEffect(() => {
    fetchProjects();
  }, [i18n.language]);


  return (
    <div className=' flex flex-col w-[100%] h-fit items-center justify-center m-auto '>
     
      {
        i18n.language === "en" ? <div className=' w-[100%] grid grid-cols tablet:grid-cols p-1 laptop:grid-cols-2 gap-1 laptop:w-[900px] desktop:grid-cols-3 desktop:w-[1240px]  desktopXL:grid-cols-4 desktopXL:w-[1650px] items-center'>
          {getProjects.map(({ _id, images, title }) => (
            <Link to={`/projects/${_id}`}
              className=' w-[100%] h-[450px] mb-6 rounded-lg grid grid-cols text-slate-100 hover:text-white laptop:grid-rows-1 grayscale-0 hover:grayscale laptop:h-[350px] laptop:w-5/6 m-auto border-2 desktop:w-[350px] desktop:h-[300px] desktopXL:w-[350px] desktopXL:h-[300px] border-slate-400 container'
              key={_id}>
              <img src={images[0]} alt={title} className='h-full w-[100%] rounded-md '/>
              <div className='flex flex-col items-center justify-center w-full h-full p-2 rounded-lg middle bgBlur'>
                <h2 className='text-3xl text-center uppercase font-englishTitle '>{title}</h2>
              </div>
            </Link>
          )).reverse()}
        </div> : i18n.language === "fa" ? <div className='w-[100%] grid grid-cols tablet:grid-cols p-1 laptop:grid-cols-2 gap-1 laptop:w-[900px] desktop:grid-cols-3 desktop:w-[1240px]  desktopXL:grid-cols-4 desktopXL:w-[1650px] items-center'>
          {getProjectsPersian.map(({ _id, images, pTitle }) => (
            <Link
              to={`/projects/${_id}`}
              className='w-[100%] h-[450px] mb-6 rounded-lg grid grid-cols text-slate-100 hover:text-white laptop:grid-rows-1 grayscale-0 hover:grayscale laptop:h-[350px] laptop:w-5/6 m-auto border-2 desktop:w-[350px] desktop:h-[300px] desktopXL:w-[350px] desktopXL:h-[300px] border-slate-400 container'
              key={_id}
            >
              <img src={images[0]} alt={pTitle} className='h-full w-[100%] rounded-md' />
              <div className='flex flex-col items-center justify-center w-full h-full p-2 rounded-lg middle bgBlur'>
                <h2 className='mt-20 mb-8 text-3xl text-center uppercase font-persianTitle text-slate-100'>{pTitle}</h2>
              </div>
            </Link>
          )).reverse()}
        </div> : i18n.language === "ar" ? <div className='w-[100%] grid grid-cols tablet:grid-cols p-1 laptop:grid-cols-2 gap-1 laptop:w-[900px] desktop:grid-cols-3 desktop:w-[1240px]  desktopXL:grid-cols-4 desktopXL:w-[1650px] items-center'>
          {getProjectsArabic.map(({ _id, images,  aTitle }) => (
            <Link
              to={`/projects/${_id}`}
              className='w-[100%] h-[450px] mb-6 rounded-lg grid grid-cols text-slate-100 hover:text-white laptop:grid-rows-1 grayscale-0 hover:grayscale laptop:h-[350px] laptop:w-5/6 m-auto border-2 desktop:w-[350px] desktop:h-[300px] desktopXL:w-[350px] desktopXL:h-[300px] border-slate-400 container'
              key={_id}
            >
              <img src={images[0]} alt={aTitle} className='h-full w-[100%] rounded-md' />
              <div className='flex flex-col items-center justify-center w-full h-full p-2 rounded-lg middle bgBlur'>
                <h2 className='mt-20 mb-8 text-3xl text-center uppercase font-persianTitle text-slate-100'>{aTitle}</h2>
              </div>
            </Link>
          )).reverse()}
        </div> : ''
      }
    </div>
  );
}
